import { render } from "./FriendListItem.vue?vue&type=template&id=2b34868a"
import script from "./FriendListItem.vue?vue&type=script&lang=js"
export * from "./FriendListItem.vue?vue&type=script&lang=js"
script.render = render

export default script